/**
 * Coloured heading bar above each SDQ report section.
 * `className` carries the background that encodes the risk level.
 */
const SdqSectionTitleBar = (props) => {
  const { className, children } = props;

  return <div className={`rounded px-3 py-2 text-center ${className}`}>{children}</div>;
};

export default SdqSectionTitleBar;
